import { useEffect, useState } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { api, centsToUSD } from "@/lib/api";
import { useT } from "@/context/ContentContext";
import { ShoppingBag } from "lucide-react";

export default function Shop() {
  const t = useT();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/shop")
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      <main className="mx-auto max-w-7xl w-full px-6 py-16 flex-1">
        <div className="overline mb-3">{t("shop.page.overline", "Team Shop")}</div>
        <h1 className="font-display uppercase text-4xl sm:text-5xl text-chrome">{t("shop.page.title", "Rep the Dymes")}</h1>
        <p className="mt-4 text-white/65 max-w-2xl">{t("shop.page.subtitle", "")}</p>

        {loading ? (
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {[0,1,2].map((i) => <div key={i} className="card-dark h-80 animate-pulse" />)}
          </div>
        ) : items.length === 0 ? (
          <div className="card-dark mt-12 p-12 text-center text-white/60" data-testid="shop-empty">
            <ShoppingBag className="mx-auto mb-3 text-[#00E5FF]" />
            Stock is on the way! Check back soon.
          </div>
        ) : (
          <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="shop-grid">
            {items.map((it) => (
              <article key={it.id} className="card-dark overflow-hidden flex flex-col" data-testid={`shop-item-${it.id}`}>
                <div className="aspect-[4/3] overflow-hidden bg-black/60 relative">
                  {it.image_url ? (
                    <img src={it.image_url} alt={it.name} className="h-full w-full object-cover transition-transform duration-500 hover:scale-105" />
                  ) : (
                    <div className="h-full w-full grid place-items-center text-white/30">
                      <ShoppingBag size={48} />
                    </div>
                  )}
                  <div className="absolute top-3 left-3 text-[10px] uppercase tracking-[0.25em] bg-black/60 px-2 py-1 rounded">
                    {it.category}
                  </div>
                </div>
                <div className="p-5 flex-1 flex flex-col">
                  <div className="font-varsity text-xl tracking-wider">{it.name}</div>
                  <div className="mt-1 font-display text-2xl text-chrome">{centsToUSD(it.price_cents)}</div>
                  {it.description && <p className="mt-2 text-sm text-white/60 leading-relaxed line-clamp-3">{it.description}</p>}
                  {Array.isArray(it.sizes) && it.sizes.length > 0 && (
                    <div className="mt-3 flex flex-wrap gap-1">
                      {it.sizes.map((s) => (
                        <span key={s} className="text-[10px] uppercase tracking-[0.2em] border border-white/15 text-white/60 px-2 py-0.5 rounded">
                          {s}
                        </span>
                      ))}
                    </div>
                  )}
                  <div className="mt-auto pt-5">
                    <button className="btn-ghost w-full" disabled data-testid={`shop-buy-${it.id}`}>
                      {it.in_stock ? "Coming Soon" : "Sold Out"}
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </main>

      <Footer />
    </div>
  );
}
